import Renderer from "./Renderer";

export default abstract class RowRenderer extends Renderer {
  abstract getColumn(): any;
}
